<div class="sa-form-group">
  <label class="sa-form-label">{{title}} <span *ngIf="required != 'none'" style="color:red"> *</span></label>
  <select id="{{TagId}}" class="form-select" style="border:solid 1px rgb(206, 212, 218);" [ngModel]="Id" (ngModelChange)="change($event)">
    <option *ngFor="let o of options" [value]="o[IdField]">
      {{ o[NameField] }}
    </option>
  </select>
</div>
